import Vue from 'vue';
import moment from 'moment';
import BootstrapVue from 'bootstrap-vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store/store';
import Layout from '@/pages/Layout.vue';
import ChatHub from '@/chat-hub';
import ChatHubInstaller from '@/chat-hub-installer';
import '@/auth-installer';
import i18n from '@/i18n';

Vue.component('layout', Layout);
Vue.prototype.moment = moment;
Vue.config.productionTip = false;

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);
Vue.use(BootstrapVue);
declare module 'vue/types/vue' {
  interface Vue {
    $chatHub: ChatHub;
  }
}
Vue.use(new ChatHubInstaller());

new Vue({
  router,
  store,
  i18n,
  render: (h: any) => h(App)
}).$mount('#app');
